// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.block-option[data-v-d593b6e2] {\n\tcursor: pointer;\n}\n.block-name[data-v-d593b6e2] {\n\tfont-weight: 600;\n}\n.block-description[data-v-d593b6e2] {\n\tfont-size: 12px;\n\tcolor: var(--main-gray-5);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
